import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function MapComponent({ position }) {
  // Icona personalizzata per il marker
  const customIcon = L.icon({
    iconUrl: "./img/immagini/icons8-indirizzo.png",
    iconSize: [40, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  });

  return (
    <MapContainer center={position} zoom={13} style={{ height: "300px", width: "100%", position: "relative" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={position} icon={customIcon}></Marker>
      <a href="#">
        <div id="arrowup">
          <img
            width="30"
            height="30"
            style={{ marginTop: "6px" }}
            src="https://img.icons8.com/ios/50/FFFFFF/double-up.png"
            alt="double-up"
          />
        </div>
      </a>
    </MapContainer>
  );
}

export default MapComponent;
